<template>
  <div></div>
</template>

<script>

  import Vue from 'vue'

  export default {
    name: 'vue',
    props: {
      template: {
        type: String,
        required: true
      },
      config: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data () {
      return {}
    },
    mounted () {
      let settings = _.assign(this.config, {
        el: this.$el,
        template: this.template,
        parent: this
      })
      new Vue(settings)
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/_global/vue.vue